import { render, staticRenderFns } from "./EditStockistPackage.vue?vue&type=template&id=4a17d58c"
import script from "./EditStockistPackage.vue?vue&type=script&lang=js"
export * from "./EditStockistPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports